module.exports = __webpack_public_path__ + "img/educemplois.f10ce9a7.png";